import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import useDynamicColors from "../../../../../hooks/useDynamicColors";

export const PhoneStep2VisaMobile = () => {
  const colors = useDynamicColors();
  const location = useLocation();
  const navigate = useNavigate();

  const inputs = Array.from({ length: 6 }, () => useRef(null));

  const handleChange = (e, index) => {
    const value = e.target.value;
    if (value.length > 1) return;

    if (/^[0-9]?$/.test(value)) {
      if (value && index < 5) {
        inputs[index + 1].current.focus();
      }
    }
  };

  const handleButtonClick = () => {
    const currentParams = location.search;
    navigate(`/vxlab-onboarding_skan_id_01-visa-mobile${currentParams}`);
  };

  const styles = {
    telefono: {
      fontFamily: "Open Sans, sans-serif",
      marginTop: "30px",
      backgroundColor: "#f1f1f1",
      display: "flex",
      borderRadius: "50px",
      border: "15px solid #000000",
      flexDirection: "row",
      justifyContent: "center",
      width: "100%",
    },
    arrow: {
      fontSize: "26px",
      marginLeft: "8px",
    },
    containerPhone: {
      width: "100%",
      margin: "0 auto",
      fontFamily: "sans-serif",
      padding: "20px",
    },
    description: {
      fontSize: "15px",
      marginTop: -60,
      color: "#333",
      marginBottom: "20px",
      lineHeight: "1.5",
    },
    lines: {
      display: "flex",
      flexDirection: "column",
      marginRight: "8px",
    },
    lineBlue: {
      width: "30px",
      height: "6px",
      backgroundColor: colors.primario,
      marginBottom: "4px",
    },
    lineYellow: {
      width: "30px",
      height: "6px",
      backgroundColor: colors.secundario,
    },
    containerStep: {
      display: "flex",
      alignItems: "baseline",
      fontFamily: "sans-serif",
    },
    current: {
      color: colors.primario,
      fontSize: "40px",
      fontWeight: "bold",
    },
    separator: {
      margin: "0 2px",
      color: "#959699",
      fontSize: "18px",
    },
    inputGroup: {
      display: "flex",
      justifyContent: "space-between",
      gap: "8px",
      marginBottom: "12px",
    },
    input: {
      width: "40px",
      height: "50px",
      fontSize: "20px",
      textAlign: "center",
      border: "1px solid #ccc",
      borderRadius: "6px",
      outline: "none",
      padding: "12px",

    },
    resend: {
      color: colors.primario,
      background: "none",
      border: "none",
      cursor: "pointer",
      padding: "0",
      fontSize: "14px",
      textDecoration: "underline",
    },
    total: {
      color: "#959699",
      fontSize: "18px",
    },
    page: {
      fontFamily: "Open Sans, sans-serif",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "30px",
      position: "relative",
      backgroundColor: "#ffffff",
      width: "375px",
      height: "812px",
      overflow: "hidden",
      boxShadow: "0 0 20px rgba(0,0,0,0.1)",
    },
    container: {
      display: "flex",
      padding: "16px",
      height: "100%",
      boxSizing: "border-box",
      alignItems: "center",
      margin: "16px 0 8px 0",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "16px",
      height: "160px",
      width: "90%",
      borderBottom: "1px solid #E7E7E7",
    },
    title: {
      fontSize: "18px",
      marginBottom: "20px",
      color: "#333",
    },
    checkboxContainer: {
      display: "flex",
      alignItems: "flex-start",
      gap: "10px",
      width: "90%",
      marginBottom: "40px",
    },
    checkbox: {
      marginTop: "4px",
      transform: "scale(1.2)",
      accentColor: "#0052cc",
    },
    label: {
      lineHeight: "1.5",
      display: "block",
      fontSize: "14px",
      fontWeight: "500",
      marginBottom: "8px",
      color: "#111",

    },
    button: {
      width: "90%",
      padding: "12px",
      height: "54px",
      backgroundColor: colors.primario,
      color: "#fff",
      fontSize: "16px",
      border: "none",
      borderRadius: "6px",
      cursor: "pointer",
      position: "absolute",
      bottom: 16,
    },
  };

  return (
    <div style={styles.telefono}>
      <div style={styles.page}>
        <div style={styles.header}>
          <div style={{display: "flex", gap: 12}}>
            {colors.url_logo !== "" ? (
                <img className="inicio-de-sesion-de-2" src={colors.url_logo}
                     style={{height: 70, maxWidth: 120, objectFit:'contain'}}/>) : (<></>)}
          </div>
          <div style={styles.containerStep}>
            <span style={styles.current}>02</span>
            <span style={styles.separator}> / </span>
            <span style={styles.total}>06</span>
          </div>
        </div>
        <div
            style={{
              ...styles.container,
              width: "100%",
              flexDirection: "column",
              justifyContent: "initial",
              alignItems: "center",
            }}
        >
          <div style={styles.containerPhone}>
            <div
                style={{transform: "scale(0.5)", transformOrigin: "top left"}}
            >
              <svg
                  width="115"
                  height="145"
                  viewBox="0 0 115 145"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
              >
                <path
                    d="M61.5803 111.956C62.5159 112.7 63.5193 117.083 64.5257 118.26H27.2711C26.6218 118.26 24.6001 117.246 23.8859 116.909C25.8751 115.642 27.8348 114.264 29.4787 112.556L29.7089 112.127C40.189 111.95 50.2914 111.98 61.5803 111.956Z"
                    fill={colors.secundario}
                />
                <path
                    d="M17.9704 54.3699C17.7783 54.3502 17.5875 54.3428 17.4037 54.3181C17.4026 54.2541 17.4011 54.1889 17.4 54.1255C17.5884 54.211 17.7797 54.2895 17.9704 54.3699Z"
                    fill={colors.secundario}
                />
                <path
                    d="M0.429027 34.1884C1.58916 16.1706 16.0515 1.67456 34.0655 0.469364C36.1342 0.326694 37.9251 1.89607 38.0641 3.9648C38.203 6.03352 36.6373 7.82441 34.5686 7.96333C20.2978 8.91697 8.84284 20.402 7.92675 34.6728C7.79909 36.6589 6.14712 38.187 4.18352 38.187C4.10092 38.187 4.02208 38.187 3.93948 38.1795C1.87075 38.0443 0.301378 36.2609 0.432785 34.1922L0.429027 34.1884Z"
                    fill={colors.secundario}
                />
                <path
                    d="M38.852 24.723C31.0501 24.723 24.705 31.0681 24.705 38.8699C24.705 40.9424 23.023 42.6244 20.9506 42.6244C18.8781 42.6244 17.1961 40.9424 17.1961 38.8699C17.1961 26.9307 26.9089 17.214 38.852 17.214C40.9244 17.214 42.6065 18.896 42.6065 20.9685C42.6065 23.041 40.9244 24.723 38.852 24.723Z"
                    fill={colors.secundario}
                />
                <path
                    d="M47.6811 15.9324C54.0091 15.9299 60.3414 16.0076 66.5869 16.1621C73.1353 16.5138 78.4797 21.3504 78.9549 28.1708C79.0469 43.7925 78.9591 48.5917 78.6842 63.6238L78.6622 64.8229H73.0653H72.7727L72.4801 39.5757L64.5904 39.565H36.2083H34.8518L34.8501 32.6602L50.7259 32.6713H72.4727V28.0152C72.4715 26.0488 69.037 22.8307 66.998 22.7887L50.1925 22.7739C49.641 20.3443 48.7867 18.0483 47.6811 15.9324Z"
                    fill={colors.secundario}
                />
                <path
                    d="M42.1477 78.331C42.9623 82.4769 46.2441 84.6264 50.2343 84.9476C56.2462 85.431 62.866 84.5634 68.9428 84.9386C69.9699 96.0193 72.9065 107.136 78.6616 116.611C77.8204 117.004 73.2134 120.39 72.7795 120.06C67.9305 111.198 64.7313 101.597 63.0166 91.5822C54.133 90.9818 44.8069 93.9359 38.4644 85.8422C36.9622 83.9239 34.7871 78.7723 34.7871 76.3827V71.8795C34.7871 71.8465 35.1973 71.4292 35.2298 71.4292H77.0472L91.8717 86.6408L114.573 130.09L109.391 133.233L108.703 132.828L86.5741 90.8407L74.3998 78.331H42.1477Z"
                    fill={colors.primario}
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M23.3023 94.0777C22.8685 93.6544 22.2517 93.7775 22.414 93.1981C27.1332 90.0249 28.1219 82.6818 24.2114 78.4398C29.2404 72.2585 25.8877 62.3366 17.8453 61.5261C14.4011 61.1778 5.95148 63.3423 7.16742 57.2391C7.66915 54.7293 10.0361 55.2217 10.3372 54.9184C10.5615 54.6933 10.3372 49.3736 10.3372 48.464C10.3372 47.8035 7.53339 48.53 7.03166 48.6981C-0.618185 51.2739 -1.95809 62.0454 4.76504 66.5215C3.20379 70.4903 3.13591 74.9064 6.15807 78.1816C1.71337 83.4383 3.45465 91.9492 10.042 94.2488C5.21364 99.2263 6.18168 107.71 12.589 110.712C22.8449 115.522 31.6546 102.192 23.3023 94.0777ZM16.9658 81.6341C16.0244 81.526 13.4774 81.499 12.6097 81.6971C9.47536 82.4176 9.50488 87.8093 13.1321 88.2447C14.0971 88.3617 16.6028 88.3737 17.5384 88.2206C20.7494 87.7013 21.2099 82.1264 16.9658 81.6341ZM13.5511 101.709C13.5511 103.543 15.0121 105.032 16.8124 105.032C18.6127 105.032 20.0736 103.543 20.0736 101.709C20.0736 99.8747 18.6127 98.3857 16.8124 98.3857C15.0121 98.3857 13.5511 99.8747 13.5511 101.709ZM10.4109 72.7058C11.1576 75.6509 17.3643 75.6719 19.0731 74.0267C21.3663 71.8202 19.7047 68.4849 16.6707 68.1246C13.5807 67.7584 9.32485 68.4189 10.4109 72.7058Z"
                    fill={colors.primario}
                />
                <path
                    d="M41.8508 125.165H51.1268L65.1103 139.425L60.5091 144.057L41.8508 125.165Z"
                    fill={colors.primario}
                />
              </svg>
            </div>
            <p style={styles.description}>
              We texted you a one-time verification code. Enter the code below.
            </p>
            <div style={styles.inputGroup}>
              {inputs.map((ref, i) => (
                  <input
                      key={i}
                      ref={ref}
                      maxLength={1}
                      style={styles.input}
                      onChange={(e) => handleChange(e, i)}
                  />
              ))}
            </div>
            <button style={styles.resend}>Resend Code</button>
          </div>
          <button onClick={handleButtonClick} style={styles.button}>
            Next
          </button>
        </div>
      </div>
    </div>
  );
};
